module.exports = __webpack_public_path__ + "assets1783936157458/img/logo-block.b2a020b6.png";